var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39686 15.0953C2.43515 14.7507 2.45429 14.5784 2.50642 14.4174C2.55268 14.2745 2.61802 14.1386 2.70069 14.0132C2.79388 13.8719 2.91645 13.7493 3.1616 13.5042L14.1669 2.49895C15.0873 1.57847 16.5797 1.57848 17.5002 2.49895C18.4207 3.41942 18.4207 4.91181 17.5002 5.83228L6.49493 16.8375C6.24978 17.0827 6.12721 17.2052 5.9859 17.2984C5.86054 17.3811 5.72457 17.4464 5.5817 17.4927C5.42067 17.5448 5.24838 17.564 4.9038 17.6023L2.0835 17.9156L2.39686 15.0953Z",
    stroke: "#344054",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.fd99586944ce5c775cead719ddce0210.svg";
export { ForwardRef as ReactComponent };